(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-login-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseB2bLoginGuard = () => {
      const guard = document.querySelector('[data-b2b-login-guard]');

      if (!guard || guard.hasAttribute('data-b2b-login-guard-ready')) return;

      const focusableElements = Array.from(guard.querySelectorAll('a[href]'));
      const primaryAction = guard.querySelector('[data-b2b-login-primary]');

      guard.setAttribute('data-b2b-login-guard-ready', '');
      document.body.classList.add('b2b-login-guard-active');

      if (primaryAction) {
        window.requestAnimationFrame(() => primaryAction.focus());
      }

      guard.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          return;
        }

        if (event.key !== 'Tab' || focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseB2bLoginGuard, { once: true });
    } else {
      initialiseB2bLoginGuard();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
